import { featureItems } from '@/mocks/features';

export default function FeatureSection() {
  return (
    <section id="feature" className="scroll-mt-20 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-50 px-3 py-1 text-xs font-bold text-accent-700 ring-1 ring-accent-200">
            <i className="ri-book-open-line" />
            深度专题
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">不只看瓜，也看懂瓜</h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            在即时速报之外，把热点背后的规律、频道的用法与围观文化讲清楚，让追更更尽兴也更从容。
          </p>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-3">
          {featureItems.map((f) => (
            <article
              key={f.id}
              className="group flex flex-col overflow-hidden rounded-3xl border border-background-200/80 bg-background-50 transition hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={f.image}
                  alt={`${f.title}专题封面插画`}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-bold text-background-50">
                  {f.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-6">
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-time-line" />
                  {f.minutes}
                  <span className="text-background-200">·</span>
                  {f.meta}
                </div>
                <h3 className="mt-3 text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {f.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{f.excerpt}</p>
                <a
                  href="#feed"
                  className="mt-5 inline-flex items-center gap-1.5 self-start whitespace-nowrap rounded-full bg-primary-50 px-4 py-2 text-sm font-semibold text-primary-700 ring-1 ring-primary-200 transition hover:bg-primary-100"
                >
                  展开阅读
                  <i className="ri-arrow-right-line transition group-hover:translate-x-1" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}